import { Classification } from '@/domain/Classification'
import axios from 'axios'

/**
 * 検査分類サービス
 */
export default class ClassificationsService {
    /** インスタンス */
    private static _instance: ClassificationsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ClassificationsService();
        }
        return this._instance;
    }
    
    /**
     * 新規作成
     */
    public async createNew(): Promise<Classification> {
        return await axios.get("/api/classification/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<Classification> {
        return await axios.get(`/api/classification/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: Classification): Promise<Classification> {
        return await axios.post("/api/classification/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Classification): Promise<Classification> {
        return await axios.put(`/api/classification/edit/${dto.code}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 検査分類一覧を検索
     */
    public async findAll(): Promise<Classification[]> {
        return await axios.get("/api/classifications")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Classification[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Classification {
        const classification = data as Classification
        return new Classification({ ...classification })
    }
}
